<!-- components/Products.vue -->
<template>
  <section class="features" ref="productSection" id="services">
    <transition name="fade" appear>
      <h2 v-if="isVisible">{{ lMessages["title"] }}</h2>
    </transition>
    <transition-group name="slide-up-fast" tag="div" class="products-grid">
      <div
        v-for="(feature, index) in features"
        :key="index"
        class="products-item"
        :style="{ transitionDelay: `${index * 0.1}s` }"
        v-show="isVisible"
      >
        <img :src="feature.image" alt="Feature Image" class="product-image" />
        <div class="product-content">
          <h3 v-if="feature.title != null">{{ feature.title }}</h3>
          <h3 v-else>
            <img
              :src="logo"
              @mouseover="logo = logo_blue"
              @mouseout="logo = logo_black"
              alt=""
              style="height: 1.6rem"
            />
          </h3>
          <p>{{ feature.text }}</p>
        </div>
      </div>
    </transition-group>
  </section>
</template>

<script>
export default {
  props: {
    lMessages: { required: true, default: () => [] }
  },
  data() {
    return {
      features: [],
      isVisible: false,
      logo_black: require("@/assets/images/QuanspireLogoBlack.svg"),
      logo_blue: require("@/assets/images/QuanspireLogoBlue.svg"),
      logo: require("@/assets/images/QuanspireLogoBlack.svg")
    };
  },
  created() {
    this.features = this.lMessages["prods"];
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const section = this.$refs.productSection;
      const rect = section.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.8) {
        this.isVisible = true;
      } else if (rect.top > window.innerHeight * 0.01) {
        this.isVisible = false;
      }
    }
  }
};
</script>

<style scoped>
.features {
  padding: 4rem 2rem;
  text-align: center;
  background: var(--whiter-gray);
}

h2 {
  font-size: 2.5rem;
  color: var(--blacker-gray);
  margin-bottom: 3rem;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.products-item {
  position: relative;
  padding: 2rem;
  background: #f8f9fa;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.product-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 1rem;
}

.product-content {
  color: var(--lightBackgroundFixed);
}

h3 {
  font-weight: 600;
  font-size: 1.6rem;
  margin-bottom: 0.5rem;
  color: var(--blacker-gray);
}

p {
  font-size: 1rem;
  color: var(--textInactiveFixedWhiteBg);
}

/* Animaciones */
.fade-enter-active {
  transition: opacity 0.8s ease;
}
.fade-enter {
  opacity: 0;
}

.slide-up-fast-enter-active {
  transition: all 0.5s ease;
}
.slide-up-fast-enter {
  opacity: 0;
  transform: translateY(100px);
}
</style>
